import { z } from 'zod';
import { requiredString } from '../helpers';
export const Front_Send_Channel_Message_1_ConfigValidator = z.object({
    frontAccountId: requiredString('Front Account ID is required'),
    channelId: requiredString('Channel is required'),
    senderHandle: requiredString('Sender handle is required'),
    senderName: z.string().optional(),
    subject: z.string().optional(),
    body: requiredString('Message body is required')
});
//# sourceMappingURL=front-send-channel-message-1.js.map